export const FRONTEND_ROUTES = {
  auth: {
    register: "/auth/register",
    loginClinic: "/auth/tenant/login", // 👈 De clinic a tenant
    loginPatient: "/auth/patient/login",
    loginSuperadmin: "/auth/superadmin/login",
    registerClinic: "/auth/tenant/register", // 👈 De clinic a tenant
    registerPatient: "/auth/patient/register",
    unauthorized: "/auth/unauthorized",
    forgotPasswordClinic: "/auth/tenant/forgot-password", // 👈 De clinic a tenant
    forgotPasswordPatient: "/auth/patient/forgot-password",
    invitation: (token: string) => `/auth/invite/${token}`,
    setPasswordClinic: (token: string) => `/auth/tenant/set-password/${token}`, // 👈 De clinic a tenant
    setPasswordPatient: (token: string) =>
      `/auth/patient/set-password/${token}`,
    resetPassword: "/auth/set-password",
  },
  ob: {
    step_1: "/onboarding/step-1",
    step_2: "/onboarding/step-2",
    step_3: "/onboarding/step-3",
    step_4: "/onboarding/step-4",
  },
  superadmin: {
    help: "/superadmin/help",
    helpArticleId: (id: string, language: string) =>
      `/superadmin/help/${id}?language=${language}`,
    platformExerciseCategories: "/superadmin/platform/exercise-categories",
    platformExerciseCategoryId: (id: string, language: string) =>
      `/superadmin/platform/exercise-categories/${id}?language=${language}`,
    platformExercises: "/superadmin/platform/exercises",
    platformExerciseId: (id: string, language: string) =>
      `/superadmin/platform/exercises/${id}?language=${language}`,
    platformProtocols: "/superadmin/platform/protocols",
    platformProtocolId: (id: string, language: string) =>
      `/superadmin/platform/protocols/${id}?language=${language}`,
    platformSpecialties: "/superadmin/platform/specialties",
    platformSpecialtyId: (id: string, language: string) =>
      `/superadmin/platform/specialties/${id}?language=${language}`,
    platformServiceCategories: "/superadmin/platform/service-categories",
    platformServiceCategoryId: (id: string, language: string) =>
      `/superadmin/platform/service-categories/${id}?language=${language}`,
    platformServices: "/superadmin/platform/services",
    platformServiceId: (id: string, language: string) =>
      `/superadmin/platform/services/${id}?language=${language}`,
    dashboard: "/superadmin/dashboard", // 👈 Independiente de /app
    professionals: "/superadmin/professionals", // 👈 Independiente de /app
  },
  tenant: {
    analytics: "/tenant/analytics",
    settings: "/tenant/settings",
    dashboard: "/tenant/dashboard", // 👈 ¡Adiós /app, hola /tenant!
    availability: "/tenant/availability",
    professionals: "/tenant/professionals",
    staff: "/tenant/staff",
    bookings: "/tenant/bookings",
    bookingId: (id: string) => `/tenant/bookings/${id}`,
    bookingManage: (id: string) => `/tenant/bookings/${id}/manage`,
    clinics: "/tenant/clinics",
    clinicId: (id: string) => `/tenant/clinics/${id}`,
    protocolId: (id: string, language: string) =>
      `/tenant/protocols/${id}?language=${language}`,
    exerciseId: (id: string, language: string) =>
      `/tenant/exercises/${id}?language=${language}`,
    exerciseCategoryId: (id: string, language: string) =>
      `/tenant/exercise-categories/${id}?language=${language}`,
    serviceId: (id: string, language: string) =>
      `/tenant/services/${id}?language=${language}`,
    serviceCategoryId: (id: string, language: string) =>
      `/tenant/service-categories/${id}?language=${language}`,
    specialtyId: (id: string, language: string) =>
      `/tenant/specialties/${id}?language=${language}`,
    helpArticleId: (id: string, language: string) =>
      `/tenant/specialties/${id}?language=${language}`,
    patientId: (id: string) => `/tenant/patients/${id}`,
    profileId: (id: string) => `/tenant/profile/${id}`,
    professionalId: (id: string) => `/tenant/professionals/${id}`,
    staffId: (id: string) => `/tenant/staff/${id}`,
    services: "/tenant/services",
    clinicSettings: {
      calendar: "/tenant/settings/?tab=calendar",
    },
    stripe: {
      successUrl: "/tenant/settings/?tab=billing",
      cancelUrl: "/tenant/settings/?tab=cancel",
    },
  },
  patient: {
    selectClinic: "/patient/select-clinic",
    dashboard: "/patient/dashboard",
    bookings: "/patient/bookings",
    myHistory: "/patient/my-history",
    clinics: "/patient/clinics",
    profile: "/patient/profile",
    bookingsHistory: "/patient/bookings/my-history",
    bookingsNewService: "/patient/bookings/new/service",
    bookingsNewProfessional: "/patient/bookings/new/professional",
    bookingsNewDate: "/patient/bookings/new/date",
    bookingsNewTime: "/patient/bookings/new/time",
    bookingsNewConfirm: "/patient/bookings/new/confirm",
    bookingsNewSuccess: "/patient/bookings/new/success",
  },
  public: {
    homeClinic: "/",
    homePatient: "/info-patients",
    contact: "/contact",
    legalPrivacy: "/privacy-policy",
    legalTerms: "/terms-and-conditions",
    legalCookies: "/cookie-policy",
    legalNotice: "/legal-notice",
    booking: (clinicSlug: string) => `/book/${clinicSlug}`,
  },
};
